module.exports = __webpack_public_path__ + "static/orb_of_dragonkind-961d12b36f9fcf356b160428ace50a23.jpeg";